export default function Footer() {
  return (
    <footer className="bg-emerald-600 text-white text-center py-4">
      <p>© 2026 Sujita Regmi. All rights reserved.</p>
    </footer>
  );
}
